import { globalPut } from "../index";

export const editTracking = (data) => {
  return globalPut(
    `/tracking?user=${data?.userInfoRedux?.id}`,
    data?.updateTimesheetVal
  );
};
